export default __webpack_public_path__ + "static/GT-America-Standard-Regular-eefae472c4eca16331249fc14970b901.ttf";